// Mapping of underwriter names to their Accelerant member IDs
export const UNDERWRITER_MAPPING: Record<string, string> = {
  "amanda constanza": "8c0e8c3d-b05a-4ca4-96cb-4c9d16236bb1",
  "brock hoskin": "de1f1447-c050-4c2e-8da0-b81707aab216",
  "elizabeth ernst": "478ad26c-173f-4d9c-b748-a2b352d94ad9",
  "farid nagji": "4e4c6f32-6c7d-4cb0-9a3b-7f34f22128a0",
  "hannah hill": "13df03f5-eec5-4faa-af46-42eb90d5304b",
  "hunter gordon": "c136109f-1414-4fe7-ab41-d8598bd28759",
  "janelle duffy": "20ee9701-6a28-4c5a-a275-1c65df0c5514",
  "jeff lewis": "d5536c10-cc3c-4f85-b878-e43f334f0987",
  "jennifer limper": "f2445960-8c1b-4658-8348-e29a652b17bb",
  "jessica todd": "80ed58b0-a156-4adf-8e7f-07f92a79f796",
  "joe strickland": "72fcc0c1-de1d-40ba-b9e4-c1a78b1ef333",
  "joshua belanger": "dbc04f92-0b7c-4a30-8e71-23759d0b476c",
  "lejla kusari": "8ce655b4-cb8f-4233-b72e-f07f241bd552",
  "lindsey tingler": "31899585-66ad-4bd8-bbfc-095f90c2f2a5",
  "sierra ready": "08f2e801-5b5a-4ecf-a4de-05763c3940c1",
  "suzanne merced": "332725d0-f27b-4997-be26-7d50ff917a1a",
  "taylor campbell": "cb50ae21-eb2f-4b72-9c74-7ec9d4fd4fa2",
  "tony pickens": "f38165c8-f014-449f-a1bc-9c78f0a788a5",
  "tyler guilmette": "39fa8a0d-6130-497f-a13f-47b15222d000",
  "will johnson": "e36473de-a76d-4c6d-848a-eff4aaa4769d",
};

export function getUnderwriterId(underwriterName: string): string | undefined {
  const normalizedName = underwriterName.toLowerCase().trim();

  if (UNDERWRITER_MAPPING[normalizedName]) {
    return UNDERWRITER_MAPPING[normalizedName];
  }

  if (normalizedName.includes(",")) {
    const parts = normalizedName.split(",").map((part) => part.trim());
    const reorderedName = `${parts[1]} ${parts[0]}`.toLowerCase();
    if (UNDERWRITER_MAPPING[reorderedName]) {
      return UNDERWRITER_MAPPING[reorderedName];
    }
  }

  for (const [name, id] of Object.entries(UNDERWRITER_MAPPING)) {
    if (name.includes(normalizedName) || normalizedName.includes(name)) {
      return id;
    }
  }

  return undefined;
}
